/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxIsoClosedIcon20Solid = forwardRef('DeliveryBoxIsoClosedIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.562 1.916a3 3 0 0 1 2.876 0l5 2.73c.27.148.513.335.72.55l-2.836 1.56-7.15-4.08 1.39-.76Z" }),
        React.createElement("path", { d: "m5.883 3.38-2.32 1.267c-.272.147-.514.334-.722.55L10 9.132l3.038-1.67-7.155-4.084Z" }),
        React.createElement("path", { d: "m10.625 10.216 7.196-3.958c.117.323.18.668.18 1.022v5.447a3 3 0 0 1-1.563 2.633l-5 2.73a2.997 2.997 0 0 1-.813.302v-8.176Z" }),
        React.createElement("path", { d: "M9.375 10.216v8.176c-.28-.06-.554-.16-.813-.301l-5-2.73A3 3 0 0 1 2 12.726V7.28c0-.354.062-.7.18-1.022l7.195 3.958Z" })));
});
